import React from "react";
import InventarioBase, { InventarioPageConfig } from "./InventarioBase";

const config: InventarioPageConfig = {
  documentTitle: "Stock - Inventario de control | Saas",
  breadcrumbTitle: "Inventario de control",
  breadcrumbSection: "Stock",
  conceptoEditable: false,
  conceptoPredeterminado: "Inventario de control",
  contextLabel: "Inventario de control",
  contextPluralLabel: "Inventarios de control",
  headerTitle: "Datos principales",
  headerDescription: "Completá los datos antes de cargar artículos.",
  detailTitle: "Detalle de artículos",
  detailDescription: "Agregá artículos y depósito/salida.",
  tabRegisterLabel: "Registrar control",
  tabListLabel: "Listado control",
  tabRegisterLabelMobile: "Registrar",
  tabListLabelMobile: "Listado",
  apiPath: "/api/stock/inventarios/control",
};

const InventarioControlPage: React.FC = () => <InventarioBase config={config} />;

export default InventarioControlPage;
